import { ActionType, createAsyncAction } from 'typesafe-actions'
import { Failure, Request, Success } from './types'
import { ChatState } from '../../types'

export const promoteAdminGroupAction = createAsyncAction(
  '@chat/PROMOTE_ADMIN_GROUP_REQUEST',
  '@chat/PROMOTE_ADMIN_GROUP_SUCCESS',
  '@chat/PROMOTE_ADMIN_GROUP_FAILURE'
)<Request, Success, Failure>()

const request = (state: ChatState): ChatState => ({
  ...state,
  isLoadingPromoteAdminGroup: true
})

const success = (state: ChatState, action: ActionType<typeof promoteAdminGroupAction.success>): ChatState => {
  const { updatedChatData } = action.payload
  return {
    ...state,
    activeChat: { ...state.activeChat, ...updatedChatData },
    isSuccessOnPromoteAdminGroup: true,
    isLoadingPromoteAdminGroup: false
  }
}
const failure = (state: ChatState): ChatState => ({
  ...state,
  isLoadingPromoteAdminGroup: false,
  isErrorOnPromoteAdminGroup: true
})

export const promoteAdminGroupHandle = { asyncAction: promoteAdminGroupAction, request, success, failure }
